!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react"), require("prop-types"), require("@leafygreen-ui/emotion"), require("@leafygreen-ui/lib")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion", "@leafygreen-ui/lib"], t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Checkmark = e.Checkmark || {}, e.Checkmark.js = t(e.React, e.PropTypes, e["@leafygreen-ui/emotion"], e["@leafygreen-ui/lib"]));
}(this, function (e, t, r, n) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var i = l(t);

  function a() {
    return (a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function o(e, t) {
    if (null == e) return {};

    var r,
        n,
        l = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          l = {},
          i = Object.keys(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || (l[r] = e[r]);
      }

      return l;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
      }
    }

    return l;
  }

  var u = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  function c() {
    var e,
        t,
        r = (e = ["\n    color: ", ";\n  "], t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    })));
    return c = function c() {
      return r;
    }, r;
  }

  var f = n.IdAllocator.create("Checkmark"),
      s = function s(t) {
    var n,
        l,
        i,
        s = t.className,
        p = t.size,
        d = void 0 === p ? 16 : p,
        m = t.title,
        y = t.titleId,
        b = t.fill,
        g = o(t, ["className", "size", "title", "titleId", "fill"]),
        h = e.useMemo(function () {
      return y || f.generate();
    }, [y]),
        k = r.css(c(), b);
    return m = function (e, t) {
      return !1 === t ? null : null == t || !0 === t ? "".concat(e.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon") : t;
    }("Checkmark", m), e.createElement("svg", a({
      className: r.cx((n = {}, l = k, i = null != b, l in n ? Object.defineProperty(n, l, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[l] = i, n), s),
      height: "number" == typeof d ? d : u[d],
      width: "number" == typeof d ? d : u[d]
    }, g, {
      viewBox: "0 0 16 16",
      role: "img",
      "aria-labelledby": h
    }), void 0 === m ? e.createElement("title", {
      id: h
    }, "Glyphs / Checkmark") : m ? e.createElement("title", {
      id: h
    }, m) : null, e.createElement("desc", null, "Created with Sketch."), e.createElement("g", {
      id: "Glyphs-/-Checkmark",
      stroke: "none",
      strokeWidth: 1,
      fill: "none",
      fillRule: "evenodd"
    }, e.createElement("path", {
      d: "M6.94974747,10.363961 L13.3137085,4 L14.7279221,5.41421356 L8.36396103,11.7781746 L6.94974747,13.1923882 L2,8.24264069 L3.41421356,6.82842712 L6.94974747,10.363961 Z",
      fill: "currentColor"
    })));
  };

  return s.displayName = "Checkmark", s.isGlyph = !0, s.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, s;
});